import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import Log from './Log.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/otp-messages'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'otp_messages_settings_index',
          component: Index,
          meta: {
            featureFlag: FEATURE_FLAGS.OTP_MESSAGES,
            permissions: ['administrator'],
          },
        },
        {
          path: 'log',
          name: 'otp_messages_settings_log',
          component: Log,
          meta: {
            featureFlag: FEATURE_FLAGS.OTP_MESSAGES,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
